import { atom } from 'jotai';

export const viewModeAtom = atom('columns');
export const numColumnsAtom = atom(1);
export const numRowsAtom = atom(1);